import React, { memo } from 'react';

import { Connect } from '@rover/react-lib/src/components/utils/Redux';
import { selectors as searchFiltersSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import {
  effects as searchPageEffects,
  selectors as searchPageSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchPage.duck';
import { selectors as frontendConfigurationSelectors } from '@rover/react-lib/src/redux/ducks/frontendConfiguration.duck';
import { selectors as petsSelectors } from '@rover/react-lib/src/redux/ducks/pets.duck';
import {
  actions as searchActions,
  selectors as searchSelectors,
} from '@rover/react-lib/src/redux/ducks/search.duck';
import { selectors as serviceTypeSelectors } from '@rover/react-lib/src/redux/ducks/serviceTypes.duck';

import SidebarFiltersCollection from './SidebarFiltersCollection';

export type Props = {
  onScrollableFilterChange: () => void;
  onUpdateInnerHeight: () => void;
};

const effects = {
  updateFiltersAndFireSearchOnChange: searchPageEffects.updateFiltersAndFireSearchOnChange,
};

const actions = {
  toggleIsShowingPriceInCurrency: searchActions.toggleIsShowingPriceInCurrency,
};

const selector = (state) => ({
  currencyCode: searchSelectors.getSearchCurrencyCode(state),
  countryCode: searchSelectors.getSearchCountryCode(state),
  getPriceUnit: serviceTypeSelectors.getPriceUnit(state),
  getServiceTypeBySlug: serviceTypeSelectors.getServiceTypeBySlug(state),
  hasPets: searchSelectors.getHasPets(state),
  isCatOnly: searchFiltersSelectors.getIsCatOnly(state),
  language: frontendConfigurationSelectors.getLanguage(state),
  petOptions: petsSelectors.getPets(state),
  petSizeBuckets: searchSelectors.getSearchDogSizeBuckets(state),
  priceFilterMaxValue: searchPageSelectors.getPriceFilterMaxValue(state),
  priceFilterMinValue: searchPageSelectors.getPriceFilterMinValue(state),
  searchFilters: searchFiltersSelectors.getFilters(state),
  serviceTypeFilterOptions: searchFiltersSelectors.getServiceTypeFilterOptions(state),
  serviceTypeOptions: searchFiltersSelectors.getPetTypeBrowsableServiceTypeOptions(state),
  weightUnit: searchSelectors.getSearchWeightUnit(state),
  queryDerivedData: searchSelectors.getQueryDerivedData(state),
  priceTransparencyLevel: searchSelectors.getPriceTransparencyLevel(state),
  isShowingPriceInCurrency: searchSelectors.getIsShowingPriceInCurrency(state),
  cardTreatment: searchSelectors.getCardTreatment(state),
});

const SidebarFiltersCollectionContainer = (props: Props): JSX.Element => (
  <Connect selector={selector} effects={effects} actions={actions}>
    {(connectedProps) => <SidebarFiltersCollection {...connectedProps} {...props} />}
  </Connect>
);

export default memo(SidebarFiltersCollectionContainer);
